import React, { Component } from 'react'
import DataGrid from "../../components/DataGrid";
import Pagination from "../../components/Pagination";
import FinancialBox from "../../components/boxes/FinancialBox";
import ProductViewBox from './ProductViewBox';
import SidebarView from '../../components/SidebarView';
import { checkTranslation, imageAddress, priceStandardView, translate } from '../../utils/useful';
import Collapsible from 'react-collapsible';
import Responsive from '../../components/Responsive';
import Monitor from "../DeskViews/Monitor";
import { TouchPitchHandler } from 'mapbox-gl';
import CommerceInvoiceCalculations from '../../components/CommerceInvoiceCalculations';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import CustomLoader from '../../components/CustomLoader';
import HttpServices from '../../utils/Http.services'
// import { loadStripe } from '@stripe/stripe-js';

// import { CardCvcElement, CardElement, CardExpiryElement, CardNumberElement, Elements, ElementsConsumer } from "@stripe/react-stripe-js";

// const stripe = await loadStripe('pk_test_51Ohdj6DMRcpHzxaloAZPOwxlK1spVe7SBwpmFdo0e86e1RxYOpwJEIZdUaMzhY7k2nOfRqilU9koavXrsU9jZBKO00jI4MLDAP');
// const elements = stripe.elements();
export class CartPayment extends Component {
    state = {
        // showCollapse: null,
        // active: false,
        selected: 0,
        collapses: {},

        paymentOptions: [
            // { name: 'Stripe', image: "/assets/stripe.png", description: "{{lang}}Integrated 24-month warranty (compatible, supported (Vista) and Avageng)", },
            // { name: 'PayPal', image: "/assets/PayPal.jpg", description: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptates beatae facilis necessitatibus, sint modi consequuntur ab quibusdam quas", },
        ],

        deliveries: [
            // { name: 'Fast delivery', _id: 1, price: 0, description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. At omnis iure magnam facere numquam reprehenderit laboriosam hic culpa. Beatae quaerat odit quia cumque dolor dicta ad aliquid ducimus esse totam.' },
            // { name: 'Normal delivery', _id: 2, price: 40, description: "This will be delivered as early as February 9, 2024" },
        ],

        // checkBox: {},

        // show: false,

        products: [
            // { name: '{{lang}}airpod pro 2nd generation', colort: "{{lang}}White", colorb: "#fff", image: "/images/productbuy.png", warranty: "{{lang}}Integrated 24-month warranty (compatible, supported (Vista) and Avageng)", shop: "{{lang}}Apple Store", availability: "{{lang}}In Stuck", shipping: "{{lang}}From 1 To 2 Works Day", price: "$250" },
            // { name: '{{lang}}airpod pro 2nd generation', colort: "{{lang}}White", colorb: "#fff", image: "/images/productbuy.png", warranty: "{{lang}}Integrated 24-month warranty (compatible, supported (Vista) and Avageng)", shop: "{{lang}}Apple Store", availability: "{{lang}}In Stuck", shipping: "{{lang}}From 1 To 2 Works Day", price: "$250" },


        ],

        prices: [
            // { price: "$250", title: 'tax', code: '0' },
            // { price: "$250", title: 'Subtotal', code: '0' },
            // { price: "Free", title: 'Shipment Cost', code: '0' },
            // { price: "-$12", title: 'Discount', code: '1' },

        ],
        // filter: [
        //     { name: 'Categories' },
        //     { name: 'Brand' },
        //     { name: 'Price' },
        // ],
        // option: [
        //     { name: "Discounts and offers", src: '/assets/icons/target.svg' },
        //     { name: "best sellers", src: '/assets/icons/flame.svg' },
        //     { name: "amazing", src: '/assets/icons/chart.svg' },
        // ],
        type: [
            { name: "{{lang}}No items saved for later", des: "{{lang}}" },
            { name: "{{lang}}Buy it again", des: "{{lang}}No items to Buy again" },
        ],

        // colors: { color: "white" },

        // weeks: [
        //     { week: "Sunday", date: "18", t1: "5 pm to 6 pm", t2: "4 pm to 6 pm", t3: "19 to 21", },
        //     { week: "Monday", date: "19", t1: "13 to 16", t2: "15 to 17", t3: "19 to 21", },
        //     { week: "Tuesday", date: "20", t1: "12 to 16", t2: "17 to 18", t3: "19 to 21", },
        //     { week: "Wednesday", date: "21", t1: "15 to 19", t2: "06 to 08", t3: "19 to 21", },
        //     { week: "Thursday", date: "22", t1: "15 to 17", t2: "17 to 19", t3: "19 to 21", },
        //     { week: "Friday", date: "23", t1: "15 to 17", t2: "17 to 19", t3: "19 to 21", },
        //     { week: "Saturday", date: "24", t1: "15 to 17", t2: "17 to 19", t3: "19 to 21", },
        // ],

        // shippingTime: { time: "Sunday 2 january 4pm until 6pm" },
        prices: [
            { price: "$250" },
        ],

        shippingPrice: [
            { price: "free" },
        ],

        totalPrice: { price: "$250" },

        // voucher: [
        //     { type: "Gift Card Code" },
        //     { type: "Discount Voucher" },
        //     { type: "" },
        //     { type: "Gift Card" },
        //     { type: "Gift Card" },
        // ],

        // voucherError: { error: "This code has been used before." },

        // voucherAccept: { accept: "This code has sucssusfuly redeemed." },

        addresses: [
            { title: "Home", address: "4555 Hopyard Rd", city: "Pleasanton", zipcode: "94588", phonenumber: "+1 (345) 454-5554", name: "Hossein Mohseni", },
            { title: "Work", address: "6160 Chambersburg Rd", city: "Atlanta", zipcode: "30338", phonenumber: "+1 (345) 454-5554", name: "Hossein Mohseni", },
            { title: "Mom's House", address: "827 Lincolnway E", city: "Chicago", zipcode: "34553", phonenumber: "+1 (345) 454-5554", name: "Ellena Mohseni", },
            { title: "Office", address: "893 Smithfield Ave", city: "Pleasanton", zipcode: "83246", phonenumber: "+1 (345) 454-5554", name: "Hossein Mohseni", },
        ],

        // deliveryType: [
        //     { title: "Normal Shiping" },
        //     { title: "Express Shiping" },
        //     { title: "Pick up at Store" },
        // ],
        paymentStatus: "",
        email: "",
        cardholderName: "",
        country: "",
        isFocusedCardNumber: false,
        isFocusedCardExpiry: false,
        isFocusedCardCvc: false,
    }

    // showNotifications = () => {

    // }

    // openSidebar = () => {
    //     this.sidebarView.openSidebar()
    // }
    // handleCollapse = (index) => {
    //     if (this.state.showCollapse == index) {
    //         this.setState({ active: !this.state.active })
    //     } else {
    //         this.setState({ showCollapse: index, active: true })
    //     }
    // }
    async componentDidMount() {


        this.setState({ currentIndex: 0, currentItem: this.state.type[0] })
        this.getPaymentGateways()

        let appletId = this.props.variables?.appletId ?? this.props.applet?._id
        let cart = this.props.carts?.applets[appletId]

        if (cart.voucher) {
            this.createVoucherStatus(cart)
        }
    }



    getPaymentGateways = () => {
        if (!this.state.isLoadingPost) {
            this.setState({ isLoadingOptions: true })
            let appletId = this.props.variables?.appletId ?? this.props.applet?._id
            let cart = this.props.carts?.applets[appletId]

            let body = {
                applet: appletId,
                cart: cart._id
            }


            HttpServices.request('getPaymentTypes', body, (fetchResult, fetchError, fetchStatus) => {

                this.setState({ isLoadingOptions: false })

                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                    return
                }

                this.setState({ paymentOptions: fetchResult.info })

            })
        }
    }




    submitOrder = (e) => {

        let appletId = this.props.variables?.appletId ?? this.props.applet?._id
        let cart = this.props.carts?.applets[appletId]



        if (this.state.payment) {
            this.handleSubmit(e)
        } else {
            if (!this.state.isLoadingPost) {
                if (this.state.selectedPayment) {
                    this.setState({ isLoadingPost: true })
                    let body = {
                        cart: cart._id,
                        payment: this.state.selectedPayment
                    }
                    HttpServices.request('postOrder', body, (fetchResult, fetchError, fetchStatus) => {
                        console.log('postOrder', body, fetchResult, fetchError)
                        this.setState({ isLoadingPost: false })

                        if (fetchError) {
                            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                            return
                        }

                        if (fetchResult.info.client_secret) {
                            this.setState({ order: fetchResult.info, payment: true, clientSecret: fetchResult.info.client_secret }, () => {

                                // cart number
                                // this.cardNumberElement = elements.create('cardNumber');
                                // this.cardNumberElement.mount('#card-number-element');

                                // this.CardExpiryElement = elements.create('cardExpiry');
                                // this.CardExpiryElement.mount('#card-expiry-element');

                                // this.CardCvcElement = elements.create('cardCvc');
                                // this.CardCvcElement.mount('#card-cvc-element');

                                // this.cardElement = elements.create('card');
                                // this.cardElement.mount('#card-element');



                            })
                        }
                        // this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postSuccesfully', description: '{{lang}}Address updated successfully' })

                    })

                } else {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}Select payment type', description: "{{lang}}Payment type is required for posting the order." })
                }
            }
        }
    }





    revokeVoucher = () => {


        if (!this.state.isLoadingPostRevoke) {
            this.setState({ isLoadingPostRevoke: true })

            let appletId = this.props.variables?.appletId ?? this.props.applet?._id
            let cart = this.props.carts?.applets[appletId]

            let body = {
                cart: cart?._id,
                applet: appletId
            }

            HttpServices.request('revokeVoucher', body, (fetchResult, fetchError, fetchStatus) => {

                this.setState({ isLoadingPostRevoke: false })

                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                    return
                }

                this.setState({ voucherResult: {} })


                this.props.actions.setCart(fetchResult.info)

                this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postSuccesfully', description: '{{lang}}Address updated successfully' })

            })
        }
    }


    verifyVoucher = () => {


        if (!this.state.isLoadingPostVoucher) {

            this.setState({ voucherResult: {} }, () => {

                if (this.state.voucherCode && this.state.voucherCode.length > 3) {

                    let appletId = this.props.variables?.appletId ?? this.props.applet?._id
                    let cart = this.props.carts?.applets[appletId]

                    this.setState({ isLoadingPostVoucher: true })
                    let body = {
                        cart: cart?._id,
                        code: this.state.voucherCode,
                        applet: appletId
                    }
                    HttpServices.request('verifyVoucher', body, (fetchResult, fetchError, fetchStatus) => {

                        this.setState({ isLoadingPostVoucher: false })

                        if (fetchError || !fetchResult || !fetchResult.info) {
                            let voucherResult = { error: fetchError.message }
                            this.setState({ voucherResult })

                            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.not valid', description: fetchError.message })
                            return
                        }
                        this.props.actions.setCart(fetchResult.info)
                        this.createVoucherStatus(fetchResult.info)
                        // let cart = fetchResult.info
                        // let currency = "$"
                        // let description = '{{lang}}Voucher is approved. ' + currency + fetchResult?.info?.voucher + ' discount is applied.'

                        // let voucherResult = { info: fetchResult.info, description: description, approved: true }
                        // this.setState({ voucherResult })

                        this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.voucherApproved', description: '{{lang}}Your voucher is approved and can be used.' })

                    })
                } else {
                    let voucherResult = { error: '{{lang}}Please insert the voucher code correctly.' }
                    this.setState({ voucherResult })
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}Code not valid', description: voucherResult.error })
                }

            })

        }

    }


    createVoucherStatus(cart) {

        let voucherInfo
        let voucher = cart.voucher


        if (voucher && Array.isArray(cart.amounts?.adjustments)) {

            cart.amounts?.adjustments.forEach(adjustment => {
                if (adjustment.type == 'voucher') {

                    voucherInfo = adjustment

                }
            });


            if (voucherInfo) {
                let currency = "$"
                let description = '{{lang}}Voucher is approved. ' + currency + voucherInfo?.amount + ' discount is applied.'

                let voucherResult = { description: description, approved: true }

                this.setState({ voucherCode: voucher.code, voucherResult })

            }
        }

    }







    changeCollapse = (index) => {
        let collapses = this.state.collapses ?? {}
        collapses[index] = !collapses[index]
        this.setState({ collapses })
    }


    renderItem(props) {
        return (
            <div className={'d-flex  pb-3 pt-1th-3 bb-gray ' + (this.props.width < 576 ? ' flex-wrap' : '')}>

                <Responsive className={''} width={this.props.width} media={this.props.col ?? { xs: "100%", sm: '100px' }}>

                    <div >
                        <img width={'100%'} className='br-5' style={{ aspectRatio: '1 / 1', objectFit: 'cover', maxWidth: 100 }} src={imageAddress(props.product?.media)} onClick={() => this.changePage('product', ['product', props.product?._id])} alt='' />
                    </div>

                </Responsive>

                <Responsive className={''} width={this.props.width} media={this.props.col ?? { xs: "100%" }}>

                    <div className={' w-100 ' + (this.props.width < 576 ? '' : 'pld-4')}>

                        {props.product?.type == 'membership' && (
                            <div className='mb-1' >
                                <p className='font-size-14 weight-500 '>{translate("Subscribe")}: {checkTranslation(props.product?.name)} - {props?.variants?.repeat} {translate(props?.variants?.duration)}</p>
                            </div>
                        )}

                        {props.product?.type != 'membership' && (
                            <button className='mb-1' onClick={() => this.goToProduct(props)}>
                                <p className='font-size-14 weight-500 '>{checkTranslation(props.product?.name)}</p>
                            </button>
                        )}


                        {props.product?.type == 'membership' && (
                            <p className='text-smaller'>USD {props?.variants?.price} ✕ {props.count} = USD {props?.variants?.price * props.count} / month</p>
                        )}

                        {props.product?.type == 'membership' && props?.variants?.duration == 'year' && (
                            <p className='text-smaller'>{translate("Billed annualy")}</p>
                        )}


                        {props.product?.type != 'membership' && props?.variants && (
                            <div className='w-100'>
                                {Object.entries(props?.variants)?.map(([key, value]) => {
                                    return (
                                        <p className='font-size-12 weight-400 main-c7 mld-1 ' style={{ textTransform: 'capitalize', marginTop: 2 }}><span className='font-size-12 weight-400'>{key}:</span> {value}</p>
                                    )
                                })}
                            </div>
                        )}

                        {typeof props?.additionals == 'object' && (
                            <div className='w-100'>
                                {Object.entries(props?.additionals)?.map(([key, value]) => {
                                    return (
                                        <div>
                                            <span className='font-size-12 weight-400 main-c7 mld-1' style={{ textTransform: 'capitalize' }}>{key}:
                                                {typeof value == 'object' && Object.entries(value)?.map(([optionKey, optionValue], oindex) => {
                                                    return (
                                                        <span>
                                                            {optionKey == 'text' ? (
                                                                <span className='font-size-12 weight-400 main-c7 mld-1' style={{ textTransform: 'capitalize' }}> {optionValue?.value}</span>

                                                            ) : (
                                                                <>
                                                                    <span className='font-size-12 weight-400 main-c7 mld-1' style={{ textTransform: 'caspanitalize' }}>{optionKey}
                                                                        {optionValue?.priceDifference && (
                                                                            <span className='font-size-12 weight-400 main-c7 mld-1'>
                                                                                ({(optionValue?.value != true && optionValue?.value > 1) ? (optionValue?.value + "*" + optionValue?.priceDifference) : ("$" + optionValue?.priceDifference)})
                                                                            </span>
                                                                        )}
                                                                    </span>

                                                                </>
                                                            )}
                                                            {(oindex < (Object.entries(value).length - 1)) && (
                                                                <span className='mld-1'>,</span>
                                                            )}
                                                        </span>
                                                    )
                                                })}
                                            </span>
                                        </div>
                                    )
                                })}
                            </div>
                        )}

                        <div className='flexcb w-100 mt-2 prd-3' >
                            <div className=''>
                                <div className='flexc'>
                                    <p className='font-size-14 weight-500  '> ${priceStandardView(props.amounts?.final)}</p>

                                    {(props.amounts?.final != props.amounts?.base) && (
                                        <p className='font-size-12 main-c4 text-lined mld-2'>${priceStandardView(props.amounts?.base)}</p>
                                    )}
                                    {(props?.price?.onSale && !props.amounts?.additionals) && (
                                        <p className='font-size-12 mld-2  px-2 br-30' style={{ color: '#fff', backgroundColor: "rgb(204, 12, 57)" }}>{props.product?.price?.discount?.value}{props.product?.price?.discount?.unit ?? '%'}</p>
                                    )}
                                </div>
                            </div>

                            <div className='px-2'>
                                <p className='text-smaller text-semibold flexc ' style={{ whiteSpace: 'nowrap' }}>{translate("Quantity")} <span className='mld-1'>{props.count}</span></p>
                            </div>
                            {/* <div className='flexcb br-30 p-1 ' style={{ border: '1px solid #eee', backgroundColor: '#f6f6f6' }}>
            <button onClick={() => this.addToCart('subtract', 1, props, index)} className='br-30'>
                <img width={20} className='flexcc' style={{ opacity: '.7' }} src='/assets/icons/minimize.svg' />
            </button>
            <div className='px-3 position-relative'>
                {this.state.isLoading[index] && (
                    <div className='w-100 flexcc' style={{ position: 'absolute', top: 6, left: 0 }}>
                        <CustomLoader isLoading={true} type={'ThreeDots'} color={'#444'} height={10} />
                    </div>
                )}

                <p className='main-c4 weight-700' style={{ color: this.state.isLoading[index] ? 'transparent' : null }}>{props.count}</p>

            </div>
            <button onClick={() => this.addToCart("add", 1, props, index)} className='br-30'>
                <img width={20} className='flexcc' style={{ opacity: '.7' }} src='/assets/icons/plus.svg' />
            </button>
                 </div> */}
                        </div>


                    </div>

                </Responsive>
            </div>
        )
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        // const cardNumberEl = elements.getElement(CardNumberElement);
        // const cardCvEl = elements.getElement(CardCvcElement);
        // const cardExpEl = elements.getElement(CardExpiryElement);
        // console.log('carddddddd1', elements)
        // console.log('carddddddd2', cardNumberEl)
        // return
        if (!this.state.isLoadingPost) {

        //     this.setState({ isLoadingPost: true })

        //     const { clientSecret } = this.state;

        //     if (!stripe || !elements || !cardNumberEl) {
        //         // if (!stripe || !elements || !this.cardElement) {
        //         this.setState({ isLoadingPost: false })
        //         return;
        //     }

        //     const { paymentIntent, error } = await stripe.confirmCardPayment(clientSecret, {
        //         payment_method: {
        //             card: cardNumberEl,
        //             // card: this.cardElement,
        //         },
        //     });
        //     console.log('carddddddd111', paymentIntent);
        //     if (error) {
        //         console.log('carddddddd1', error);
        //         this.setState({ isLoadingPost: false })
        //     } else if (paymentIntent.status === 'succeeded') {
        //         this.props.successPayment(paymentIntent, () => {
        //             this.props.changeStage('success')
        //         })
        //         this.setState({ isLoadingPost: false })
        //         // this.submitOrderAfterPayment()
        //     }
        }
    };
    // submitOrderAfterPayment = () => {

    //     let cart = this.props.carts?.applets[this.props.variables?.appletId]
    //     if (!this.state.isLoadingPost) {

    //         if (this.state.selectedPayment) {
    //             this.setState({ isLoadingPost: true })
    //             let body = {
    //                 cart: cart._id,
    //                 payment: this.state.selectedPayment
    //             }
    //             HttpServices.request('postOrderAfterPayment', body, (fetchResult, fetchError, fetchStatus) => {

    //                 this.setState({ isLoadingPost: false })

    //                 if (fetchError) {
    //                     this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
    //                     return
    //                 }

    //                 if (fetchResult.info.client_secret) {
    //                     this.setState({ order: fetchResult.info, payment: true, clientSecret: fetchResult.info.client_secret }, () => {

    //                         this.cardElement = elements.create('card');
    //                         this.cardElement.mount('#card-element');



    //                     })
    //                 }
    //                 this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postSuccesfully', description: '{{lang}}Address updated successfully' })

    //             })

    //         } else {
    //             this.props.actions.addNotif({ type: 'error', title: '{{lang}}Select payment type', description: "{{lang}}Payment type is required for posting the order." })
    //         }
    //     }
    // }

    componentWillUnmount() {
        // Clean up the card element to prevent memory leaks
        // if (this.cardElement) {
        //     this.cardElement.destroy();
        // }
        // if (this.cardNumberElement) {
        //     this.cardNumberElement.destroy();
        // }
    }

    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        let colors = this.props.colors
        let background = `linear-gradient(90deg, ${colors?.primaryColor}, ${colors?.secondaryColor})`
        let cart = {}
        if (this.props.carts?.applets) {
            let appletId = this.props.variables?.appletId ?? this.props.applet?._id
            cart = this.props.carts?.applets[appletId]
        }



        const containerStyle = {
            maxWidth: "400px",
            margin: "20px auto",
            padding: "20px",
            backgroundColor: "#f9f9f9",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",
            fontFamily: "'Arial', sans-serif",
        };

        const inputStyle = {
            display: "block",
            width: "100%",
            padding: "10px",
            margin: "10px 0",
            borderRadius: "5px",
            border: "1px solid #ddd",
        };

        const buttonStyle = {
            display: "block",
            width: "100%",
            padding: "10px",
            backgroundColor: "#28a745",
            color: "white",
            border: "none",
            borderRadius: "5px",
            marginTop: "10px",
            cursor: "pointer",
        };

        const errorStyle = {
            color: "red",
            marginTop: "10px",
        };

        return (
            <div className='w-100 window-content-radius h-100 d-flex flex-column scroll-no-scrollbar pb-5' style={{ background: "#f6f6f6" }}>
                {/* <div className='mt-3 mx-3 p-2 bg-white br-10 '>
                    <div className='flexc w-100'>

                        <button className='mld-5 mrd-5 flexc commerce-progress-b' >
                            <img className='mrd-2' width={22} src='/assets/icons/commerce/cart-commerce-b.svg' />
                            <p className='font-size-14 ' style={{ whiteSpace: "nowrap" }}>{translate('Your cart')}</p>
                        </button>

                        <img width={15} src='/assets/icons/arrow-right-black.svg' />

                        <button className='mld-5 mrd-5 flexc commerce-progress-b'>
                            <img className='mrd-2' width={22} src='/assets/icons/commerce/truck-commerce-b.svg' />
                            <p className='font-size-14' style={{ whiteSpace: "nowrap" }}>{translate('Time and Delivery')}</p>
                        </button>

                        <img width={15} style={{ opacity: ".5" }} src='/assets/icons/arrow-right-black.svg' />

                        <button className='mld-5 mrd-5 flexc commerce-progress-s'>
                            <img className='mrd-2' width={22} src='/assets/icons/commerce/pay-commerce.svg' />
                            <p className='font-size-14' style={{ whiteSpace: "nowrap" }}>{translate('Payment')}</p>
                        </button>

                    </div>
                </div> */}

                <div className='d-flex flex-wrap mt-3'>
                    {!this.state.payment ? (

                        <Responsive className={''} width={this.props.width} media={this.props.col ?? { xs: "12", sm: '12', md: '8', lg: "8", xl: "9" }}>

                            <div className='mx-3 mb-2 '>


                                <div className='px-4 br-10 py-3 flexcb bg-white  '>

                                    <p className='text-bold  text-semibig'>{translate("Cart Payment")}</p>

                                </div>


                                <div className=' mb-3 mt-3 px-4 py-3 br-10 ' style={{ backgroundColor: "#fff" }}>

                                    <p className='text-bold  text-normal'>{translate("Choose payment option")}</p>
                                    {this.state.paymentOptions.map((option, index) => {
                                        return (
                                            <div className=' bb-gray' key={index}>
                                                <button className='flexc py-3 w-100 text-start' onClick={() => this.setState({ selectedPayment: option._id })}>
                                                    <div className='flexcc'>
                                                        <label className="checkbox-container " >
                                                            <input type="checkbox" checked={option._id == this.state.selectedPayment} />
                                                            <span className="radioMark"></span>
                                                        </label>
                                                    </div>
                                                    <div className='flexcc mld-2'>
                                                        <img src={'/assets/thirdparties/' + option.type + '.png'} width={40} alt='' />
                                                    </div>
                                                    <div className='mld-3 w-100'>
                                                        <p className='text-normal text-bold'>{checkTranslation(option.name)}</p>
                                                        <p className='text-smaller main-c7' style={{}}>{checkTranslation(option.description)}</p>
                                                    </div>
                                                </button>
                                            </div>
                                        )
                                    })}
                                </div>


                                <div className=' mb-3 mt-3 px-4 py-4 br-10 ' style={{ backgroundColor: "#fff" }}>
                                    <div className='' >

                                        <p className='text-bold  text-normal'>{translate("Voucher")}</p>
                                        {/* <p className='font-size-16 title-color'>{translate('Voucher')}</p> */}
                                        <p className='font-size-13 main-c7 mt-1 prd-5' style={{}}>{translate('If you have a gift card or promotional code for this commerce, you can use it here to redeem.')}</p>
                                        <div className='mt-3 flexc'>
                                            <input disabled={this.state.voucherResult?.approved || this.state.isLoadingPostVoucher} className={'font-size-18 title-color py-2 br-8 w-100 input-buy text-semibold change-placeHolder px-3 ' + (this.state.voucherResult?.error ? ' error-input ' : '') + (this.state.voucherResult?.approved ? ' valid-input ' : '')} value={this.state.voucherCode} placeholder={translate('Enter Code')} onChange={(e) => this.setState({ voucherCode: e.target.value })} style={{ height: 40, maxWidth: 300 }} />

                                            {!this.state.voucherResult?.approved && (
                                                <button className='buy-btn px-4 py-2 br-8 mld-2 position-relative ' style={{ height: 40, background: background ?? '#007aff' }} onClick={() => this.verifyVoucher()}>

                                                    <p className={'font-size-14 text-semibold ' + (this.state.isLoadingPostVoucher ? 'opacity-0' : '')}>{translate('Redeem')}</p>

                                                    {this.state.isLoadingPostVoucher && (
                                                        <div className='w-100 flexcc' style={{ position: 'absolute', top: 15, left: 0 }}>
                                                            <CustomLoader isLoading={true} type={'ThreeDots'} color={'#fff'} height={10} />
                                                        </div>
                                                    )}

                                                </button>

                                            )}



                                        </div>
                                        <div className='px-0'>
                                            {this.state.voucherResult?.error && (
                                                <p className='font-size-13 error-text mt-3' style={{ color: 'rgb(204, 12, 57)' }}>{checkTranslation(this.state.voucherResult?.error)}</p>
                                            )}

                                            {this.state.voucherResult?.approved && (
                                                <p className='font-size-13 accept-text mt-3'>{checkTranslation(this.state.voucherResult?.description)}</p>
                                            )}

                                            {this.state.voucherResult?.approved && (
                                                <button className='p-0' style={{ color: '#ee5050' }} onClick={() => this.revokeVoucher()}>
                                                    <p className='font-size-13  mt-2'>{translate("Revoke use of voucher for now?")}</p>
                                                </button>
                                            )}

                                        </div>
                                    </div>
                                </div>


                                <div className=' mb-3 mt-3 px-4 py-3 br-10 pb-4' style={{ backgroundColor: "#fff" }}>
                                    <div className='flexcb mb-2'>
                                        <p className='text-bold text-normal'>{translate('Order Summary')}</p>
                                        {/* <button className='flexc pb-1' >
                                        <img width={18} src='/assets/icons/commerce/products.svg' />
                                        <p className='font-size-14 weight-600 mld-2' style={{ color: '#184D94' }}>{translate('2 Products')}</p>
                                    </button> */}
                                    </div>
                                    {/* <div className='flexc'>
                                    <img className='mrd-2 main-c6' width={18} src='/assets/icons/commerce/time-gray.svg' />
                                    <p className='main-c6 weight-300'>Jan 22, 2023</p>
                                    <p className='main-c3 mld-2 weight-600'>from 13:00 to 15:00</p>
                                </div>
                                <div className='flexc mt-2'>
                                    <img className='mrd-2' width={18} src='/assets/icons/commerce/truck-gray.svg' />
                                    <p className='main-c6 weight-300'>{translate('Normal shipping - ')}</p>
                                    <p className='mld-2 main-c3 weight-600'>{translate('Shipping price - free')}</p>
                                </div>
                                <div className='flexc mt-2'>
                                    <img className='mrd-2' width={18} src='/assets/icons/commerce/pay-gray.svg' />
                                    <p className='main-c6 weight-300'>{translate('Payment method - ')}</p>
                                    <p className='mld-2 weight-600 main-c3'>{translate('Paypal')}</p>
                                </div> */}

                                    {cart?.fulfillmentInfo && !Array.isArray(cart.fulfillmentInfo?.groups) && cart.items.map((item, index) => {
                                        return (
                                            this.renderItem(item)
                                        )
                                    })}


                                    {cart?.fulfillmentInfo && Array.isArray(cart.fulfillmentInfo?.groups) && cart.fulfillmentInfo?.groups.map((delivery, index) => {
                                        return (
                                            <div className='d-flex mt-3'>
                                                <div className='' style={{ paddingTop: 2 }}>
                                                    <img className='mrd-3' width={18} src='/assets/icons/commerce/truck-gray.svg' />
                                                </div>
                                                <div className='w-100'>
                                                    <div className='flexc'>
                                                        <p className='text-small weight-500'>{checkTranslation(delivery?.fulfillment?.name)}</p>
                                                        <div className='mld-2 br-30 px-2 py-1' style={{ backgroundColor: '#f0f0f0' }}>
                                                            <p className='font-size-11 text-semibold'>{delivery.items?.length}{" items"}</p>
                                                        </div>
                                                    </div>
                                                    <p className='text-smaller main-c7 mt-1 w-100'>{checkTranslation(delivery.fulfillment?.description)}</p>



                                                    <button className='mt-2 ' onClick={() => this.changeCollapse(index)}>
                                                        {!this.state.collapses[index] ? (
                                                            <p className='text-link'>{translate("Show items list")}</p>
                                                        ) : (
                                                            <p className='text-link'>{translate("Hide items list")}</p>
                                                        )}
                                                    </button>
                                                    <Collapsible open={this.state.collapses[index]} transitionTime={50}>
                                                        <div className='mt-3'>
                                                            {Array.isArray(cart.items) && cart.items?.map((props, index) => {
                                                                if (delivery.items.includes(props._id))
                                                                    return (
                                                                        this.renderItem(props)
                                                                    )
                                                            })}
                                                        </div>
                                                    </Collapsible>


                                                </div>
                                            </div>
                                        )
                                    })}



                                </div>

                            </div>
                        </Responsive>

                    ) : (
                        <Responsive className={''} width={this.props.width} media={this.props.col ?? { xs: "12", sm: '12', md: '8', lg: "8", xl: "9" }}>

                           
                        </Responsive>
                    )}

                    <Responsive className='flex-1' width={this.props.width} media={this.props.col ?? { xs: "12", sm: '12', md: '4', lg: "4", xl: "3" }}>
                        <div className={'mrd-5 p-3 br-10 position-sticky  ' + (this.props.width > 768 ? '' : ' mld-5 ')} style={{ backgroundColor: "#fff", top: 15 }}>

                            <CommerceInvoiceCalculations variables={this.props.variables} taxes={this.state.taxes} voucherDiscount={this.state.voucherResult?.info?.discount} applet={this.props.applet} />

                            <div className='d-flex my-2'>
                                {/* <div>
                                    <img width={28} src='/assets/icons/exclamationmark.circle.fill.svg' />
                                </div> */}
                                <p className='font-size-12 main-c6'>Buy Continuing this step you will accept the price of paying in the next step plus shipping time.</p>
                            </div>
                            <div className=' d-flex justify-content-center mt-3'>
                                <button className='br-8 px-2 py-2 w-100 flexcc' style={{ height: '44px', background: background ?? '#007aff' }} onClick={(e) => this.submitOrder(e)}>

                                    {this.state.isLoadingPost ? (
                                        // <div className='w-100 flexcc' style={{ position: 'absolute', top: 6, left: 0 }}>
                                        <CustomLoader isLoading={true} type={'ThreeDots'} color={'#fff'} height={10} />
                                        // </div>
                                    ) : (
                                        <p className='font-size-14 white text-semibold py-1' style={{}}>{translate('Pay & Purchase')}</p>
                                    )}
                                </button>
                            </div>

                            <div className=' d-flex justify-content-center mt-1'>
                                <button className='br-30 px-5 py-2 w-100' style={{}} onClick={() => this.props.changeStage("delivery")}>
                                    <p className='font-size-14 '>{translate('Previous page')}</p>
                                </button>
                            </div>
                        </div>
                    </Responsive>
                </div >
            </div >
        )
    }
}




const mapStateToProps = state => ({ carts: state.carts, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CartPayment);